import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const MAIN_LANGUAGES = SUPPORTED_LANGUAGES.filter(
  (l) => l.code !== "en-AU" // skip duplicate variant
);

export default function LandingLanguageFlags({ className }: { className?: string }) {
  const { i18n } = useTranslation();

  return (
    <TooltipProvider delayDuration={300}>
      <div className={cn("flex items-center gap-0.5", className)}>
        {MAIN_LANGUAGES.map((lang) => {
          const isActive = i18n.language === lang.code;
          return (
            <Tooltip key={lang.code}>
              <TooltipTrigger asChild>
                <button
                  onClick={() => i18n.changeLanguage(lang.code)}
                  className={cn(
                    "text-base leading-none rounded-sm px-1 py-0.5 transition-all duration-200",
                    "hover:bg-accent/60 hover:scale-110",
                    isActive
                      ? "bg-primary/10 ring-1 ring-primary/40 scale-110"
                      : "opacity-60 hover:opacity-100"
                  )}
                  aria-label={lang.label}
                >
                  {lang.flag}
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">
                {lang.label}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}
